import React  from 'react'
import styled from '@emotion/styled'
import { Divider, ListItem, List, Icon } from "semantic-ui-react"
import {H4} from '@styles/Global.styles'

export const ListContainer = styled.div`
    padding-top: 20px;
    padding-bottom: 20px;
`

export const ListHeading = styled.div`
    display: block;
    clear: both;
`

export const ListTitle = styled(H4)`
    &&&&{
        margin-bottom: 7px;
    }
`

export const ListingSubtitle = styled.span`
    float:right;
    font-size: 16px;
    line-height: 22px;
    padding-top: 10px;
    font-weight: medium;
    letter-spacing: -0.32px;
    color: #707070;
`

export const ListDivider = styled(Divider)`
    
    &&&&{
        border-width: 3px;
        margin-top: 0 ;
        margin-bottom: 2px;
        color: #707070;
    }
`

export const InfoList = styled(List)`
    &&&&{
        margin-top: 0;
    }
`

export const ListRow = styled(ListItem)`
    border-bottom: 2px solid #707070;
    &&&&{
        padding: 30px 0;
    }
`

export const SizeInfo = styled.div`
    float: left;
`


export const ListItemTitle = styled(({left, ...others}) => <div {...others} />)`
    text-align: left;
    font-size: 18px;
    line-height: 26px;
    font-weight: bold;
    float: ${props=>props.left ? "left" : "none"};
`

export const SizeDimension = styled.div`
    text-align: left;
    font-size: 18px;
    line-height: 26px;
    font-weight: medium;
    color: #707070;
`

export const SizePicture = styled.div`
    float: right;
`
type SizeGuideType = {
    width: number
    height: number
}

export const SizeGuide = styled(({size: SizeGuideType, ...others}) => <div {...others}></div>)`
    border: 2px solid #000000;
    width: ${props=>props.size.width}px;
    height: ${props=>props.size.height}px;
    border-radius: 2px;
`
export const ListItemHeader = styled.div`
    display: block;
    clear: both;
`
export const ListItemPricing = styled.div`
    float: right;
    font-size: 18px;
    line-height: 26px;
    font-weight: medium;
    color: #3DAE2B;
`
export const ListItemDescription = styled.div`
    text-align: left;
    font-weight: Medium;
    font-size: 14px;
    line-height: 22px;
    letter-spacing: 0;
    color: #707070;
    margin-top: 16px;
    clear:both;
`


export const VehicleTypeItemAvailability = styled.div`
    float: right;
`

export const VehicleTypeItem = styled.div`
    float: left;
`

export const VehicleTypeName = styled.span`
    padding-left: 25px;
    font-size: 18px;
    font-weight: medium;
    line-height: 26px;
`
export const VehicleTypeNameShorter = styled.span`
    padding-left: 8px;
    font-size: 18px;
    font-weight: medium;
    line-height: 26px;
`
export const VehicleTypeSubName = styled.div`
    padding-left: 58px;
    font-size: 12px;
    font-weight: medium;
`

export const VehicleIcon = styled(Icon)`
    float: left;
`
export const CheckIcon = styled(Icon)`
`

export const CrossIcon = styled(Icon)`
`